import { SchemaField } from '../../../generic/serialization/schema-field';
import { SerializableObjectSchema } from '../../../generic/serialization/serializable-object-schema';
import { UserPresenceConnection } from '../user-presence-connection/user-presence-connection';

export class UserPresenceSchema extends SerializableObjectSchema {
  public static readonly connections = 'connections';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Constants = class {
    public static readonly collection = 'userPresence';
  };

  static Defaults = class {
    public static readonly connections = new Map();
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = {} as { [key: string]: import('joi').AnySchema };

    /* eslint-disable */
    parameters[UserPresenceSchema.connections] = SchemaField.mapOfObj(
      UserPresenceConnection,
      UserPresenceSchema.Defaults.connections,
    );
    /* eslint-enable */

    return parameters;
  }
}
